import React from "react"

import Layout from "../components/Layout/layout"
import AboutComponent from "../components/About/about"
import SEO from "../components/seo"

const About = () => (
  <Layout>
    <SEO title="About Stop Toxic Housing" />
    <AboutComponent />
  </Layout>
)

export default About
